import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class RpoRecommendationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params));
            return {
                success: true,
                data: response.data,
                pagination: response.pagination || {},
                message: response.message
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch RPO recommendations');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id));
            return {
                success: true,
                data: response.data,
                message: response.message
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch RPO recommendation');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'RPO recommendation created'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to create RPO recommendation');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return {
                success: true,
                data: response.data,
                message: response.message || 'RPO recommendation updated'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update RPO recommendation');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return {
                success: true,
                message: response.message || 'RPO recommendation deleted'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete RPO recommendation');
        }
    }

    async batchDelete(ids) {
        try {
            const response = await this.api.batchDelete(ids);
            return {
                success: true,
                message: response.message || 'RPO recommendations deleted successfully'
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to batch delete RPO recommendations');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        return new ApiError(error.message || defaultMessage, 500);
    }
}
